import React from 'react';
import { observer } from 'mobx-react'

import { styled } from "../../stitches.config"
import AuthorSimple from '../AuthorSimple';
//import SocialButton from "../atoms/SocialButton"
import SocialButtonLike from "../atoms/SocialButtonLike"
import SocialButtonComment from "../atoms/SocialButtonComment"
import SocialButtonShare from "../atoms/SocialButtonShare"
import { useStores, pushDataLayer } from "../../helpers"

import { IS_FEATURE_enableComments } from "../../components/common/constants/constants";
export interface Author {
    name: string;
    img: string;
    profession: string;
    url: string;
}

interface AtavistAuthorsProps {
    article: ArticleAuthor;
    blockData: Author[];
}



const AtavistAuthors: React.FC<AtavistAuthorsProps> = observer(({
    article, blockData
}) => {
    const { ArticleStore } = useStores();
    const url = ArticleStore.article.fb_url;

    return (
        <StyledAtavistAuthors>
            <Wrapper>
                <AuthorSimple authors={blockData} border={false} />
            </Wrapper>
            <Stats>
                <SocialButtonLike url={url} />
                {IS_FEATURE_enableComments && <SocialButtonComment />}
                <SocialButtonShare url={url} />
            </Stats>
        </StyledAtavistAuthors>
    );
});

const StyledAtavistAuthors = styled('div', {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    maxWidth: "840px",
    padding: "0 38px 40px 38px",
    borderBottom: "1px solid $grayscale25",
    "@bp4": {
        padding: "0 0 40px 0",
        borderBottom: "0px solid $grayscale25",
        margin: "0 auto",
    }
})

const Stats = styled('div', {
    display: "none",
    "@bp4": {
        display: "flex",
    }
})

const Wrapper = styled('div', {
    "& .avatar": {
        width: "72px",
        height: "72px",
        borderRadius: "72px",
        marginRight: "20px !important",
    },
    "& p": {
        margin: "0 0 4px 0 !important",
    },
})

export default AtavistAuthors